export const FIRST_VISIT = 'FIRST-VISIT' // 是否首次访问
export const ACCESS_TOKEN = 'ACCESS-TOKEN' // 用户token
export const CURRENT_USER = 'CURRENT-USER' // 当前用户信息
export const DESIGN_SETTING = 'DESIGN-SETTING' // 当前用户主题信息
